{
  "title": "Admin Postavke",
  "adminAccess": "Administrator Pristup",
  "userProfile": "Korisnički Profil",
  "name": "Ime:",
  "email": "Email:",
  "role": "Uloga:",
  "systemInformation": "Sistemski Informacije",
  "systemInfoDesc": "Verzija aplikacije i sistemski detalji biće ovdje.",
  "noAdminAccess": "Nemate administratorski pristup. Kontaktirajte svog administratora za administrativne opcije.",
  "scrapingSchedules": "Vremena Skrapiranja",
  "user": "Korisnik",
  "scrapingTime": "Vrijeme Skrapiranja",
  "status": "Status",
  "scheduled": "Zakazano",
  "notConfigured": "Nije Konfigurisano",
  "loading": "Učitavanje...",
  "noUsers": "Nema pronađenih korisnika.",
  "errorLoading": "Učitavanje rasporeda skrapiranja nije uspjelo",
  "dash": "\u2014"
}
